import React from 'react';
import DictionaryBrowser from '../../components/Dictionary/DictionaryBrowser';

const WordsSection = () => {
    return <DictionaryBrowser isAdmin={true} />;
};

export default WordsSection;

